module.exports = __webpack_public_path__ + "img/jisunasuo.b356c50f.jpg";